export const v2MenuItemSizeClass = {
    small: 'ov-menu-item--sm',
    large: 'ov-menu-item--lg',
};
export const v2MenuItemDangerClass = 'ov-menu-item--danger';
